import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { SoftwareToolChips } from "./softwaretoolchips.js";
import { formatLinkedThrough } from "../pages/missionsoftware_utils.js";

/**
 * Card-grid layout for the Software tab: two columns of two-tone cards,
 * each one a link to the tool's HSSI page. A NASA-blue identity panel on
 * the left holds the title, the languages and an "Open on HSSI" line; the
 * white side holds the description, then functionality and data sources as
 * two equal sections. On narrow screens the panel becomes a band on top.
 *
 * @param props.tools Array of tools from load_mission_software.
 * @return JSX
 */
export function SoftwareToolCards({ tools }) {
  return (
    <div className="softwareToolCards">
      {tools.map((tool) => {
        const via = formatLinkedThrough(tool.viaInstruments);
        const languages = tool.languages || [];
        return (
          <a
            key={tool.key}
            className="softwareToolCard"
            href={tool.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="softwareToolCardPanel">
              <span className="softwareToolCardPanelGlow" aria-hidden="true"></span>
              <span className="softwareToolCardTitle">
                {tool.name}
                <span className="visuallyHidden"> (opens on HSSI in a new tab)</span>
              </span>
              {languages.length > 0 && (
                <ul className="softwareToolChips softwareToolCardPanelLangs" aria-label="Languages">
                  {languages.map((language) => (
                    <li key={language} className="softwareToolChip softwareToolChipOnDark">{language}</li>
                  ))}
                </ul>
              )}
              <span className="softwareToolCardPanelCta" aria-hidden="true">
                Open on HSSI
                <FontAwesomeIcon icon={faUpRightFromSquare} className="softwareToolCardPanelIcon" />
              </span>
            </div>
            <div className="softwareToolCardBody">
              {tool.description && <p className="softwareToolDesc softwareToolDescClamp">{tool.description}</p>}
              {via && <div className="softwareToolVia">{via}</div>}
              <SoftwareToolChips
                functionality={tool.functionality}
                dataSources={tool.dataSources}
                languages={[]}
                stacked
                className="softwareToolCardSpecs"
              />
            </div>
          </a>
        );
      })}
    </div>
  );
}
